module.exports = __webpack_public_path__ + "img/icon-location.4646689b.svg";